import feathersClient from '@/api'

// Prueft, ob fuer einen Hersteller Anfragepflicht besteht. Die manufacturer-settings werden aus
// den Herstellern der Fahrzeugliste gepflegt, daher exakter Vergleich. Im Fehlerfall true: der
// Antrag geht dann in die Ueberpruefung, statt die Anfragepflicht still zu ueberspringen.
export default async function isManufacturerOnRequest (manufacturer) {
  if (!manufacturer) return false
  try {
    const manufacturerSettingsReq = await feathersClient.service('manufacturer-settings').find({
      query: {
        manufacturer,
        blocked: true,
        $limit: 1
      }
    })
    return manufacturerSettingsReq.total > 0
  } catch (error) {
    console.error(error)
    return true
  }
}
